var _path, _g, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_815_31947)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_815_31947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 48.1208 48.1208 62 31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C39.065 0 44.981 -1.53278e-08 62 4.73076e-07C62 8.308 62 21.9441 62 31Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_815_31947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1769 0.543945L66.5971 39.9642L66.4954 67.9038H41.458L0.412109 26.858",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4412 69.1085V87.1337C62.4412 88.0687 61.6829 88.8269 60.748 88.8269H42.7227C42.2738 88.8269 41.8429 88.6484 41.5255 88.3309L6.88858 53.694C6.57114 53.3766 6.39258 52.9457 6.39258 52.4968V34.4715C6.39258 33.5366 7.15084 32.7783 8.0858 32.7783H26.1111C26.5599 32.7783 26.9908 32.9569 27.3083 33.2743L61.9446 67.9106C62.2626 68.2287 62.4412 68.659 62.4412 69.1085Z",
    fill: "#1660CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8095 34.4948V52.5083C27.8095 53.047 27.5602 53.5269 27.1703 53.8388L24.8037 51.4722C25.2185 51.1622 25.487 50.6662 25.487 50.1076V32.791H26.1063C27.0469 32.7916 27.8095 33.5542 27.8095 34.4948Z",
    fill: "#7EB3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1708 53.8382C26.8788 54.072 26.5093 54.2115 26.1069 54.2115H8.09341C7.15287 54.2115 6.38965 53.4489 6.38965 52.5077V51.8114H23.7838C24.1663 51.8114 24.5197 51.6856 24.8043 51.4717L27.1708 53.8382Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8043 51.4721C24.5197 51.686 24.1663 51.8118 23.7837 51.8118H6.38965V34.4946C6.38965 34.0922 6.52915 33.7221 6.76289 33.4307L24.8043 51.4721Z",
    fill: "#D8E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7912 42.6905V60.7158C88.7912 61.6507 88.0329 62.409 87.0979 62.409H69.0727C68.6238 62.409 68.1929 62.2304 67.8755 61.913L33.2392 27.2761C32.9217 26.9586 32.7432 26.5277 32.7432 26.0788V8.05357C32.7432 7.11861 33.5014 6.36035 34.4364 6.36035H52.4616C52.9105 6.36035 53.3414 6.53891 53.6589 6.85635L88.2952 41.4927C88.6126 41.8107 88.7912 42.2416 88.7912 42.6905Z",
    fill: "#1660CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1426 8.06509V26.0786C54.1426 26.4884 53.9975 26.8647 53.7563 27.158L51.3018 24.7034C51.5423 24.4089 51.6874 24.0332 51.6874 23.6227V6.36133H52.4395C53.38 6.36133 54.1426 7.12455 54.1426 8.06509Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6865 6.36133V23.6227C51.6865 24.0332 51.5415 24.4089 51.3009 24.7034L33.3457 6.74821C33.639 6.50641 34.0147 6.36133 34.4251 6.36133H51.6865Z",
    fill: "#D8E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7589 69.1118V87.137C88.7589 88.072 88.0007 88.8302 87.0657 88.8302H69.0405C68.5916 88.8302 68.1607 88.6517 67.8432 88.3342L33.2069 53.6979C32.8895 53.3805 32.7109 52.9496 32.7109 52.5007V34.4754C32.7109 33.5405 33.4692 32.7822 34.4042 32.7822H52.4294C52.8783 32.7822 53.3092 32.9608 53.6266 33.2782L88.2629 67.9145C88.5804 68.232 88.7589 68.6629 88.7589 69.1118Z",
    fill: "#003C89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1107 34.4791V52.4926C54.1107 53.4332 53.3481 54.197 52.4069 54.197H46.84L44.3848 51.7418H49.9517C50.8929 51.7418 51.6555 50.978 51.6555 50.0374V32.7754H52.4069C53.3481 32.7754 54.1107 33.5386 54.1107 34.4791Z",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6556 32.7754V50.0374C51.6556 50.978 50.893 51.7418 49.9518 51.7418H44.3849L32.6904 40.0474V34.4791C32.6904 33.5386 33.453 32.7754 34.3942 32.7754H51.6556Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3849 51.7413H32.6904V40.0469L44.3849 51.7413Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8401 54.1974H34.3942C33.453 54.1974 32.6904 53.4336 32.6904 52.493V51.7422H44.3849L46.8401 54.1974Z",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7568 27.1577C53.7208 27.203 53.6811 27.2457 53.6402 27.2867C53.3327 27.5923 52.9074 27.7814 52.4393 27.7814H34.4258C33.4853 27.7814 32.7227 27.0188 32.7227 26.0783V25.3262H49.9841C50.4522 25.3262 50.8769 25.1377 51.185 24.8321C51.2259 24.7912 51.2656 24.7484 51.3022 24.7031L53.7568 27.1577Z",
    fill: "#7EB3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7811 40.6357H19.3955V40.6376H19.7811V40.6357Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7811 40.6357H19.3955V40.6376H19.7811V40.6357Z",
    fill: "#062F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6603 40.6016V40.6028H19.6006C19.6006 40.6016 19.6006 40.6016 19.6006 40.6016H19.6603Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7811 40.6357H19.3955V40.6376H19.7811V40.6357Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2143 40.3447H19.7803V40.3466H20.2143V40.3447Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0772 40.3057H19.7803V40.3069H20.0772V40.3057Z",
    fill: "#ADCEFC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7772 1.83024V25.947C27.7772 26.9576 26.9576 27.7772 25.947 27.7772H1.83024C0.81964 27.7772 0 26.9576 0 25.947V25.1398H23.3095C24.3201 25.1398 25.1398 24.3201 25.1398 23.3095V0H25.947C26.9576 0 27.7772 0.81964 27.7772 1.83024Z",
    fill: "#D8E8FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1398 0V23.3095C25.1398 24.3201 24.3201 25.1398 23.3095 25.1398H0V1.83024C0 0.81964 0.81964 0 1.83024 0H25.1398Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7752 18.7481C12.1881 18.7481 11.7119 18.2719 11.7119 17.6848V7.63459C11.7119 7.04745 12.1881 6.57129 12.7752 6.57129C13.3624 6.57129 13.8385 7.04745 13.8385 7.63459V17.6848C13.8385 18.2719 13.363 18.7481 12.7752 18.7481Z",
    fill: "#8ABF3F",
    stroke: "#8ABF3F",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 13.7233H7.74982C7.16268 13.7233 6.68652 13.2471 6.68652 12.66C6.68652 12.0728 7.16268 11.5967 7.74982 11.5967H17.8C18.3872 11.5967 18.8633 12.0728 18.8633 12.66C18.8633 13.2471 18.3872 13.7233 17.8 13.7233Z",
    fill: "#8ABF3F",
    stroke: "#8ABF3F",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_31947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add_item.c049ca68.svg";
export { ForwardRef as ReactComponent };